import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary

import { BASE_DOCUMENT_URL, BASE_URL } from '../apiConfig';

export const fetchDocuments = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_DOCUMENT_URL}`,
    payload,
  );
  return response;
};
